import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchDebtPayments = createAsyncThunk(
  "debt-payments/fetch",
  async () => {
    const response = await API.get("/debt_payments")
    return response.data.debt_payments
  },
)
